import { useHistory } from 'react-router-dom';

import { IconHome, IconSearch, IconUser } from '@tabler/icons';
import { Container, Wrapper, Button, WhiteSpace } from './styles';

interface BottomNavProps {
  selected: 'home' | 'search' | 'profile';
}

export default function BottomNav({ selected }: BottomNavProps) {
  const history = useHistory();

  return (
    <>
      <WhiteSpace />
      <Wrapper>
        <Container>
          <Button
            onClick={() => history.push('/')}
            selected={selected === 'home'}
          >
            <IconHome size={30} />
            <span>Início</span>
          </Button>
          <Button
            onClick={() => history.push('/pesquisar/propriedade')}
            selected={selected === 'search'}
          >
            <IconSearch size={30} />
            <span>Pesquisar</span>
          </Button>
          <Button
            onClick={() => history.push('/perfil')}
            selected={selected === 'profile'}
          >
            <IconUser size={30} />
            <span>Perfil</span>
          </Button>
        </Container>
      </Wrapper>
    </>
  );
}
